<template>
    <el-form
        ref="ManageNotificationsForm"
        :model="notificationsForm"
        status-icon
        class="profile-notification-form"
    >
        <el-form-item :label="getVerbose('profile_notification_form_label_unsubscribe')">
            <el-switch
                v-model="notificationsForm.unsubscribe_all"
                :active-value="true"
                :inactive-value="false"
                :active-text="getVerbose('profile_notification_form_label_unsubscribe_yes')"
                :inactive-text="getVerbose('profile_notification_form_label_unsubscribe_no')"
            ></el-switch>
        </el-form-item>
        <el-form-item
            v-if="displayProjects"
            prop="subscribe_to"
            :label="getVerbose('profile_notification_form_label_subscribe')"
        >
            <div style="margin: 15px 0;"></div>
            <el-checkbox-group
                v-model="notificationsForm.subscribe_to"
                @change="handleCheckedChange"
            >
                <el-checkbox
                    v-for="scope in availableScopesObjects"
                    :label="scope.uid"
                    :key="scope.uid"
                    class="scope-checkbox"
                >
                    {{ scope.verbose_name }}
                </el-checkbox>
            </el-checkbox-group>
        </el-form-item>
    </el-form>
</template>

<script>
import {mapGetters} from 'vuex';
import schwartz from 'schwartz';

export default {

    components: {
    },

    props: {
        user: {
            type: Object,
            required: true,
        },
        filterScopes: {
            type: Function,
            required: false,
            default(){
                return () => {return true;};
            }
        },
    },

    data: function(){

        return {
            notificationsForm: {
                unsubscribe_all: false,
                subscribe_to_all: true,
                subscribe_to: [],
            },
        };
    },

    computed: {
        ...mapGetters('fundation', [
            'getScopeModelKey',
            'getVerbose'
        ]),
        availableScopesObjects() {
            // retrieve scopes objects
            let scopes = this.$store.getters[this.getScopeModelKey.model].filter(item => {
                return this.availableScopesUid.includes(item.uid);
            }).filter(this.filterScopes);
            return this.getScopeModelKey.model ?
                schwartz(scopes, (model) => model.verbose_name) :
                [];
        },
        availableScopesUid() {
            // retrieve scopes uid available to current user
            if(Object.keys(this.user).length === 0) return [];
            return this.getScopeModelKey.key ?
                this.user[this.getScopeModelKey.key] : [];
        },
        displayProjects() {
            return !this.notificationsForm.unsubscribe_all;
        }
    },

    mounted: function(){
        // fill up form
        this.notificationsForm.unsubscribe_all = this.user.unsubscribe_all;
        this.notificationsForm.subscribe_to = this.availableScopesUid.filter((scopeUid) => {
            return !this.user.unsubscribe_to.includes(scopeUid);
        });

        // manage check all checkbox status
        let nbUserSubscriptions = this.notificationsForm.subscribe_to.length;
        if(this.availableScopesUid.length == nbUserSubscriptions) {
            this.notificationsForm.subscribe_to_all = true;
        }
    },

    methods: {

        handleCheckedChange(val) {
            let checkedCount = val.length;
            this.notificationsForm.subscribe_to_all = checkedCount === this.availableScopesUid.length;
        },
        saveNotificationsModifications(user) {
            if(!user) user = this.user;
            // code here will save the modifications for notifications management

            /*
                can be called by parent by using a reference
                the reference should be on the called component
                this.$refs[REF_ON_COMPONENT]saveNotificationsModifications();
            */

            // create list of scopes the user does NOT subscribe to
            let unsubscribeToList = this.availableScopesUid.filter((scopeUid) => {
                return !this.notificationsForm.subscribe_to.includes(scopeUid);
            });

            let item = {
                unsubscribe_all: this.notificationsForm.unsubscribe_all,
                unsubscribe_to: unsubscribeToList,
                url: user.url,
                uid: user.uid,
            };

            let model = 'users';

            if(user.uid == this.$store.getters.currentUser.uid) {
                model = 'selfUser';
            }

            this.$store.dispatch('patchItem', {
                item: item,
                model: model,
            }).then(() => {
                this.$notify.success({
                    title: this.getVerbose('profile_notification_save_successfull_title'),
                    message: this.getVerbose('profile_notification_save_successfull_message'),
                });
                this.$emit('refreshTable');
            }).catch((error)=>{
                this.$notify.warning({
                    title: this.getVerbose('profile_notification_save_failed_title'),
                    message: this.getVerbose('profile_notification_save_failed_message'),
                });
                console.error(error);
            });
        },
    },
};
</script>

<style lang="scss">
.scope-checkbox {
    margin-left: 30px !important;
    width: 100%;
}
.profile-notification-form {
    .el-form-item__label {
        text-align: left;
    }
}
</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/pages/user-profile/notifications-form.vue